import { Authorization } from '@adminPortal/_common/_services/authorization/authorization';
import { UserService } from '@adminPortal/_common/_services/user/user.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService implements Authorization {
  private readonly authorized$: BehaviorSubject<boolean>;

  constructor(private userState: UserService) {
    this.authorized$ = new BehaviorSubject(this.userState.hasAuthToken());
  }

  public getEmail(): string | null {
    return this.userState.getAuthEmail();
  }

  public setEmail(email: string): void {
    this.userState.setAuthEmail(email);
  }

  public getToken(): string | null {
    return this.userState.getAuthToken();
  }

  public setToken(token: string): void {
    this.userState.setAuthToken(token);
    this.authorized$.next(true);
  }

  public invalidateToken(): void {
    this.userState.clearAuthToken();
    this.authorized$.next(false);
  }

  public listenToAuthorized(): Observable<boolean> {
    return this.authorized$;
  }
}
